<template>
  <v-list-item
    v-if="dates.length || places.length"
    class="pl-0"
  >
    <v-list-item-avatar color="secondary" tile>
      <v-icon color="white">{{ icon[actionType] }}</v-icon>
    </v-list-item-avatar>
    <v-list-item-content>
      <entity
        v-for="(date, idx) in dates"
        :key="'date-' + idx"
        :entity="date"
      />
      <entity
        v-for="(place, idx) in places"
        :key="'place-' + idx"
        :entity="place"
      />
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import CmifUtils from '@/mixins/CmifUtils'
import Entity from '@/components/Entity'
export default {

  name: 'CmifCorrespAction',

  mixins: [CmifUtils],

  props: {
    actionType: { type: String, default: 'sent' }
  },

  components: {
    Entity
  },

  data () {
    return {
      elementsDates: [
        'date'
      ],
      elementsPlaces: [
        'placeName'
      ],
      icon: {
        sent: 'mdi-email-send',
        received: 'mdi-email-receive'
      }
    }
  },

  computed: {
    dates () {
      return this.getEntities(this.actionType, this.elementsDates)
    },
    places () {
      return this.getEntities(this.actionType, this.elementsPlaces)
    }
  }
}
</script>

<style lang="css" scoped>
</style>
